/**
 * A long ring-size list, in one row.
 *
 * 🔴 THE PROBLEM IS QUARTER SIZES, NOT SIZES. Henry, 2026-09-08: *"with 1/4" sizes, the
 * drop down becomes very long. is there an alternative method to select?"* He is right
 * about the arithmetic — 5 to 15 in halves is 21 options; in quarters it is 41. A native
 * <select> of 41 numbers is a scroll on a phone and a wall on a desktop.
 *
 * The alternative is the way a jeweler says it out loud: a WHOLE size, then a FRACTION.
 * Eleven wholes in a short dropdown, four fractions as pills that are all visible at
 * once. Two controls, one row, and it does not grow when the list does — quarters,
 * eighths, whatever the chart adds next.
 *
 * 🔴 IT REPLACES A CONTROL THAT ALREADY WORKS, AND ONLY IF IT CAN. The <select name="id">
 * this enhances is the real form control: it posts a variant, it works with scripting
 * off, it is what a screen reader gets if anything here throws. Nothing is removed until
 * a working replacement is built and every variant is reachable through it. If a single
 * option value does not parse as a number, or the rebuilt map cannot reach every value
 * the select could, this returns and the page keeps the control it had.
 *
 * ⚠️ THE SELECT IS HIDDEN, NEVER DETACHED. It stays in the form as the posted field, so
 * the variant still travels with the form exactly as before and djh-product's own
 * syncVariant() — which reads `[name="id"]` — needs to know nothing about this file. The
 * one thing this does to it is set `.value` and fire `change`, which is what a person
 * choosing an option does.
 *
 * ⚠️ NOT APPLIED TO EVERY OPTION. Only the single-option path, only when the values are
 * numeric, and only above a threshold — a five-size list is better as five options than
 * as two controls, and turning three sizes into a whole-and-fraction puzzle would be a
 * worse page for a rule that was written for a longer one.
 */
(function () {
  var MIN_VALUES = 12; // below this a plain list is the better control

  var FRACTIONS = [
    { v: 0, label: '—', a11y: 'whole size' },
    { v: 0.25, label: '¼', a11y: 'and a quarter' },
    { v: 0.5, label: '½', a11y: 'and a half' },
    { v: 0.75, label: '¾', a11y: 'and three quarters' }
  ];

  function build(select) {
    var options = Array.prototype.slice.call(select.options).filter(function (o) {
      return o.value !== '';
    });
    if (options.length < MIN_VALUES) return;

    // The label a customer reads is the variant title, and on a single-option product
    // that title IS the option value. A title carrying anything but a number — "7 —
    // sold out", a metal, a word — means this is not the control we think it is.
    // 🔴 PARSED AS A NUMBER, NOT MATCHED AS A STRING, AND THAT IS A FIX NOT A TIDY-UP.
    // The first version tested /^\d+(\.(25|5|50|75))?$/, which accepts "5" and "5.5" and
    // REJECTS "5.0" — and one rejected value makes this whole file bow out, so the
    // customer silently gets the 41-long dropdown back and nothing anywhere says why.
    //
    // CATALOG confirmed on 2026-09-08 that the ladder stores decimal strings ("5.25",
    // "7.5"), which is what this needed; what they did not sample was how a WHOLE size
    // renders. "5", "5.0" and "5.00" are the same size and any of the three is a
    // reasonable thing for a numeric column to serialise to. A quarter-size picker that
    // works on quarters and dies on whole numbers is the worst possible shape for it.
    //
    // So: is it a number, and is it a multiple of a quarter. The rounding is because
    // 7.25 - 7 is 0.25000000000000044 in binary floating point, and a bare % 0.25 test
    // rejects sizes that are perfectly valid.
    var byNumber = {};
    for (var i = 0; i < options.length; i++) {
      var raw = (options[i].textContent || '').split('—')[0].trim();
      if (!/^\d+(\.\d+)?$/.test(raw)) return;
      var n = Number(raw);
      if (!isFinite(n)) return;
      var quarters = Math.round(n * 4);
      if (Math.abs(n * 4 - quarters) > 0.001) return;
      var whole = Math.floor(quarters / 4);
      var frac = (quarters % 4) / 4;
      byNumber[whole + ':' + frac] = options[i];
    }

    var wholes = [];
    var seen = {};
    var hasQuarter = false;
    for (var k in byNumber) {
      var w = Number(k.split(':')[0]);
      if (!seen[w]) { seen[w] = true; wholes.push(w); }
      var f = Number(k.split(':')[1]);
      if (f === 0.25 || f === 0.75) hasQuarter = true;
    }
    wholes.sort(function (a, b) { return a - b; });
    if (wholes.length < 2) return;

    // 🔴 NO QUARTERS, NO SPLIT CONTROL — Henry, 2026-09-08: *"revert back to the old
    // sizing box that was similar to the bracelets."*
    //
    // He is right and the reason is the whole point of this file. It exists because 41
    // quarter sizes are an unreadable dropdown. With 21 HALVES the dropdown is fine, and
    // splitting it buys nothing while costing something real: two of the four fraction
    // pills sit permanently greyed, which reads as a broken control rather than as a size
    // the shop has not published. He asked twice why he could not press them.
    //
    // ⚠️ IT ARMS ITSELF. The moment the quarter-size variants publish — gate 7 plus one
    // BL-04 approval, the ladder is already built and priced — this test passes and the
    // split control appears with every pill live. No deploy, no push, nothing for anyone
    // to remember. That is why the file stays rather than the load being removed.
    if (!hasQuarter) return;

    var wrap = document.createElement('div');
    wrap.className = 'djh-sizepick';

    var whole = document.createElement('select');
    whole.className = 'djh-product__select djh-sizepick__whole';
    whole.setAttribute('aria-label', select.getAttribute('aria-label') || 'Size');

    var blank = document.createElement('option');
    blank.value = '';
    blank.disabled = true;
    blank.selected = true;
    blank.textContent = (select.options[0] && select.options[0].value === '')
      ? select.options[0].textContent
      : 'Choose a size';
    whole.appendChild(blank);

    wholes.forEach(function (w) {
      var o = document.createElement('option');
      o.value = String(w);
      o.textContent = String(w);
      whole.appendChild(o);
    });

    var fracWrap = document.createElement('div');
    fracWrap.className = 'djh-sizepick__fracs';
    fracWrap.setAttribute('role', 'group');
    fracWrap.setAttribute('aria-label', 'Fraction of a size');

    var fracButtons = FRACTIONS.map(function (f) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'djh-sizepick__frac';
      btn.dataset.frac = String(f.v);
      btn.textContent = f.label;
      btn.setAttribute('aria-label', f.a11y);
      btn.setAttribute('aria-pressed', 'false');
      fracWrap.appendChild(btn);
      return btn;
    });

    // A fraction the chart does not carry is DISABLED, not hidden and not silently
    // rounded. Which fractions exist can differ per whole size once a chart grows
    // unevenly, and a control that quietly moves a customer from 7¼ to 7½ has changed
    // the thing they are buying.
    var chosenFrac = 0;

    function key(w, f) { return w + ':' + f; }

    function refresh() {
      var w = whole.value;
      var anyEnabled = false;
      fracButtons.forEach(function (btn) {
        var f = Number(btn.dataset.frac);
        var exists = w !== '' && !!byNumber[key(w, f)];
        btn.disabled = !exists;
        if (exists) anyEnabled = true;
        btn.setAttribute('aria-pressed', String(exists && f === chosenFrac));
        btn.classList.toggle('is-on', exists && f === chosenFrac);
      });
      // If the size just chosen has no such fraction, fall back to the whole rather
      // than leaving a pressed pill that resolves to nothing.
      if (w !== '' && !byNumber[key(w, chosenFrac)]) {
        chosenFrac = 0;
        fracButtons.forEach(function (btn) {
          var on = Number(btn.dataset.frac) === 0 && !btn.disabled;
          btn.setAttribute('aria-pressed', String(on));
          btn.classList.toggle('is-on', on);
        });
      }
      fracWrap.hidden = !anyEnabled && w !== '';
      apply();
    }

    function apply() {
      var w = whole.value;
      if (w === '') return;
      var opt = byNumber[key(w, chosenFrac)];
      if (!opt) return;
      select.value = opt.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    whole.addEventListener('change', refresh);
    fracButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        chosenFrac = Number(btn.dataset.frac);
        refresh();
      });
    });

    // If the page arrived with a variant already chosen (a ?variant= link), start there
    // rather than making the customer re-pick something the URL already said.
    if (select.value) {
      for (var kk in byNumber) {
        if (byNumber[kk].value === select.value) {
          whole.value = kk.split(':')[0];
          chosenFrac = Number(kk.split(':')[1]);
          break;
        }
      }
    }

    wrap.appendChild(whole);
    wrap.appendChild(fracWrap);
    select.parentNode.insertBefore(wrap, select);

    // 🔴 `hidden`, NOT `.djh-visually-hidden`, AND THE DIFFERENCE WAS A REAL DEFECT.
    // The visually-hidden class sets `width: 1px`, but `.djh-product__select` sets
    // `width: 100%` from the section's own stylesheet, which loads after the theme's —
    // same specificity, later wins. So the select stayed 100% wide, absolutely
    // positioned, and pushed the DOCUMENT 27px past the viewport at every width below
    // desktop. Measured: 417 > 390 on a phone, 795 > 768 on a tablet, on every product
    // page. Invisible, and the whole page scrolled sideways because of it.
    //
    // `hidden` is `display: none`, which removes it from layout entirely — and a
    // display:none form control is still submitted, which is the only property this
    // element needs. It also makes the tabindex and aria-hidden below unnecessary.
    select.hidden = true;

    refresh();
  }

  document.querySelectorAll('[data-djh-variant-select]').forEach(build);
})();
